module.exports = __webpack_public_path__ + "static/img/our-awards_7.786abba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/our-awards_7.png
// module id = jWZr
// module chunks = 0